import React from 'react';
import _ButtonSelect from '../common/ButtonSelect';
import { ReactComponent as ChevronRight } from '../../assets/img/chevron-right.svg';

export default function SimilarTractsList({
  children: _children,
  activeTract,
  similarTracts,
  handleSimilarTractClick,
}) {
  const handleDropdownOptionClick = function () {
    // console.log('handleDropdownOptionClick called');
  };

  const _dropdownOptions = [
    {
      label: 'Show all similar tracts',
      action: handleDropdownOptionClick,
    },
    {
      label: 'Only show tracts in the same county',
      action: handleDropdownOptionClick,
    },
    {
      label: 'Only show tracts in the same state',
      action: handleDropdownOptionClick,
    },
  ];

  return (
    <div data-component-name='SimilarTractsList' className='pt-4 rounded-md bg-blue-50'>
      {/* <div className='pb-5 mx-4 border-b border-blue-100'>
        <ButtonSelect
          variant='light'
          items={dropdownOptions}
          label={dropdownOptions[0].label}
        />
      </div> */}

      <div className='pt-0'>
        <span className='px-4 text-sm text-blue-300'>Selected tract</span>

        <div className='flex-shrink-0 h-[34px]'>
          <div className='flex items-center w-full h-full gap-5 px-4 text-base text-blue-500'>
            <span className='font-bold'>{activeTract?.tractcode}</span>
            <span className='truncate whitespace-nowrap'>
              {activeTract?.countyname}, {activeTract?.statename}
            </span>
          </div>
        </div>

        <span className='flex px-4 pt-4 text-sm text-blue-300'>Similar tracts</span>

        {!similarTracts && (
          <div className='text-base text-blue-300 px-4 pb-5 pt-2'>
            Loading similar tracts...
          </div>
        )}

        {similarTracts && similarTracts.length > 0 && (
          <ul className='flex flex-col px-2 pb-3 '>
            {similarTracts?.map((record, index) => (
              <li className='flex-shrink-0 h-[34px]' key={index}>
                <button
                  type='button'
                  onClick={() => handleSimilarTractClick(record)}
                  className='relative flex items-center w-full h-full gap-5 px-2 text-base text-blue-300 rounded-sm group hover:bg-white-400'
                >
                  <span className='font-bold'>{record.tractcode}</span>
                  <span className='truncate whitespace-nowrap'>
                    {record.countyname}, {record.statename}
                  </span>
                  <div className='absolute top-0 right-0 flex items-center h-full text-base text-orange-500 opacity-0 group-hover:opacity-100'>
                    <div className='w-8 h-full bg-gradient-to-r from-white-400/0 to-white-400 '></div>
                    <div className='flex gap-2.5 pl-2 bg-white-400 pr-3'>
                      <ChevronRight />
                      <span className='translate-y-px'>Compare</span>
                    </div>
                  </div>
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>

      {similarTracts && similarTracts?.length === 0 && (
        <div className='items-center hidden h-[34px] px-4 my-2 text-base text-blue-300 group-focus-within:flex'>
          No similar tracts found
        </div>
      )}
    </div>
  );
}
